@if (user$ | async; as user) {
  <cx-page-slot data-test="header-links" position="HeaderLinks"></cx-page-slot>
} @else {
  <a
    data-test="login-btn"
    class="btn btn-primary btn--login" [routerLink]="{ cxRoute: 'login' } | cxUrl"
  >{{ 'miniLogin.signInRegister' | cxTranslate }}
    <mat-icon class="cart-icon" svgIcon="cart" data-test="login-icon"></mat-icon>
  </a>

}
